import {
  Button,
  Grid,
  IconButton,
  Popover,
  Tooltip,
  Typography,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import AssignmentIcon from "@material-ui/icons/Assignment";
import { useStylesExtraButton } from "app/common/Component/Table/TableComponent";
import IconDelete from "app/common/Icon/IconDelete";
import IconPen from "app/common/Icon/IconPen";
import {
  LAServiceRequestItemStatusEnum,
  SERVICE_REQUEST_STATUS,
  SERVICE_TREATMENT_TYPE_WARRANTY,
} from "app/common/LocalConst";
import {
  getDateTime,
  isAdmin,
  isDoctor,
  isRoleBranchManager,
  isRoleCashier,
  isRoleChiefTechician,
  isRoleHisAccountant,
  isRoleTechician,
} from "app/common/LocalFunction";
import { getOrCreateNewByServiceRequestItemId } from "app/services/DiagnosticReportService";
import { useStore } from "app/stores";
import history from "history.js";
import { observer } from "mobx-react";
import React, { memo, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const ListTreatmentMobile = () => {
  const { t } = useTranslation();
  const path = window.location.pathname;
  const {
    pageServiceRequestItem,
    handleDeleteNewServiceRequestItem,
    handleOpenTreatmentResultPopup,
    handleOpenAllocationServicePopup,
    listSelectedItem,
    resetSlected,
    setSelectedItem,
  } = useStore().patientManagementStore.serviceRequestItemStore;

  const columns = {
    ...(path !== "/treatment-management/treatment-patient-info-detail" && {
      checkbox: "Checkbox",
    }),
    stt: "STT",
    orderDate: "Ngày điều trị",
    actions: "Thao tác",
    service: "Dịch vụ",
    currentVolumeTreated: "Số lượng điều trị",
    result: "Kết quả",
    department: "Cơ sở",
    isOutsideDepartment: "Làm ngoài cơ sở",
    room: "Phòng",
    assigner: "Người chỉ định",
    orderDateDetail: "Ngày chỉ định",
    performDate: "Thời gian thực hiện",
    performer: "Người thực hiện",
    hasImg: "Đã up ảnh",
    status: "Trạng thái",
    note: "Ghi chú",
    createdInfo: "Thông tin tạo / sửa",
    createDateInfo: "Ngày tạo HT / Thời gian nhập (theo HT)",
  };

  const dataInitColumn = {
    checkbox:
      path === "/treatment-management/treatment-patient-info-detail"
        ? false
        : true,
    stt: true,
    orderDate: true,
    actions: true,
    service: true,
    currentVolumeTreated: true,
    result: true,
    department: true,
    isOutsideDepartment: true,
    room: true,
    assigner: true,
    orderDateDetail: true,
    performDate: true,
    performer: true,
    hasImg: true,
    status: true,
    note: true,
    createdInfo: true,
    createDateInfo: true,
  };
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isAdmins = isAdmin();
  const isRoleBranchManagers = isRoleBranchManager();
  const isDoctors = isDoctor();
  const isCashiers = isRoleCashier();
  const isAccountants = isRoleHisAccountant();
  const canEditTreatment =
    isAdmins || isRoleCt || isDoctors || isRoleBranchManagers;

  const canEditPatient =
    isAdmins || isCashiers || isAccountants || isRoleBranchManagers;

  const canDeletePatient =
    isAdmins || isCashiers || isAccountants || isRoleBranchManagers;
  let stt = 0;
  // Hàm kiểm tra xem 1 item có đang được chọn hay không
  const isItemSelected = (item) =>
    listSelectedItem.some((it) => it.id === item.id);

  // Lấy danh sách tất cả item trong trang hiện tại
  const allItemsInPage = (pageServiceRequestItem?.content || []).flatMap(
    (row) => row?.items || []
  );
  // lấy từ localStorage
  let dataShowMobile =
    JSON.parse(localStorage.getItem("dataMobileTreatmentCustom")) || {};
  const [visibleFields, setVisibleFields] = useState(dataInitColumn);
  useEffect(() => {
    if (Object.keys(dataShowMobile).length > 0) {
      setVisibleFields(dataShowMobile);
    }
  }, []);
  const scrollContainerRef = useRef(null);

  return (
    <Grid container spacing={1} className="w-100 m-0">
      <Grid item xs={12}>
        <div className="treatment-list-mobile">
          <div className="card-header">
            {visibleFields["checkbox"] &&
            path !== "/treatment-management/treatment-patient-info-detail" ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#008693",
                }}
              >
                <input
                  type="checkbox"
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedItem(allItemsInPage);
                    } else {
                      resetSlected();
                    }
                  }}
                  checked={
                    listSelectedItem.length > 0 &&
                    listSelectedItem.length === allItemsInPage.length
                  }
                />
                <div className="card-count">Chọn tất cả</div>
              </div>
            ) : (
              <div /> // để cố định layout ko bị đẩy nút xem thêm sang trái
            )}
            <div>
              <ExtraButton
                setVisibleColumns={setVisibleFields}
                visibleColumns={visibleFields}
                storageKey="dataMobileTreatmentCustom"
                columns={columns}
              />
            </div>
          </div>
          {(!pageServiceRequestItem?.content ||
            pageServiceRequestItem?.content.length === 0) && (
            <div style={{ textAlign: "center", padding: "10px" }}>
              Không có dữ liệu
            </div>
          )}
          {(pageServiceRequestItem?.content || []).map((row, index) => {
            return (
              <>
                <div key={index} className="treatment-card">
                  <>
                    {/* Header của ngày */}
                    {visibleFields["orderDate"] && (
                      <div className="card-header">
                        <div className="card-stt">
                          📅 Ngày điều trị:{" "}
                          {getDateTime(row?.orderDate, "", "DD/MM/YYYY")}
                        </div>
                        <div className="card-count">
                          ({row?.items?.length} dịch vụ)
                        </div>
                      </div>
                    )}
                    {/* Danh sách item trong ngày */}
                    <div className="card-body">
                      {(row?.items || []).map((item, subIndex) => {
                        stt++;
                        return (
                          <div
                            key={`${index}-${subIndex}`}
                            className="treatment-item"
                          >
                            <div className="item-header">
                              {visibleFields["checkbox"] &&
                              path !==
                                "/treatment-management/treatment-patient-info-detail" ? (
                                <span className="item-stt">
                                  <input
                                    type="checkbox"
                                    checked={isItemSelected(item)}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setSelectedItem([
                                          ...listSelectedItem,
                                          item,
                                        ]);
                                      } else {
                                        setSelectedItem(
                                          listSelectedItem.filter(
                                            (it) => it.id !== item.id
                                          )
                                        );
                                      }
                                    }}
                                  />
                                  {visibleFields["stt"] && <div>#{stt}</div>}
                                </span>
                              ) : (
                                <div /> // để cố định layout ko bị đẩy nút xem thêm sang trái
                              )}
                              {canEditTreatment && visibleFields["actions"] && (
                                <>
                                  {path ===
                                  "/treatment-management/treatment-patient-info-detail" ? (
                                    <div className="flex-center gap-2">
                                      <Tooltip
                                        title="Cập nhật điều trị"
                                        placement="top"
                                        arrow
                                      >
                                        <IconButton
                                          size="small"
                                          onClick={async () => {
                                            if (
                                              item?.itemStatus !==
                                                LAServiceRequestItemStatusEnum
                                                  .PROCESSING.value &&
                                              item?.itemStatus !==
                                                LAServiceRequestItemStatusEnum
                                                  .FINISHED.value
                                            ) {
                                              try {
                                                let { data } =
                                                  await getOrCreateNewByServiceRequestItemId(
                                                    item?.id
                                                  );
                                                if (data) {
                                                  if (
                                                    scrollContainerRef?.current
                                                  ) {
                                                    sessionStorage.setItem(
                                                      "scrollPosition",
                                                      scrollContainerRef.current
                                                        .scrollTop
                                                    );
                                                  }
                                                  history.push(
                                                    `/treatment-management/treatment-update-results-detail/${item?.id}`
                                                  );
                                                }
                                              } catch (error) {
                                                toast.error(error);
                                              }
                                            } else {
                                              if (scrollContainerRef?.current) {
                                                sessionStorage.setItem(
                                                  "scrollPosition",
                                                  scrollContainerRef.current
                                                    .scrollTop
                                                );
                                              }
                                              history.push(
                                                `/treatment-management/treatment-update-results-detail/${item?.id}`
                                              );
                                            }
                                          }}
                                        >
                                          <IconPen
                                            style={{
                                              color: "#008693",
                                            }}
                                          />
                                        </IconButton>
                                      </Tooltip>

                                      {isAdmin() &&
                                        item?.itemStatus ===
                                          LAServiceRequestItemStatusEnum.NEW
                                            .value && (
                                          <Tooltip
                                            title="Xóa chỉ định dịch vụ"
                                            placement="top"
                                            arrow
                                          >
                                            <div
                                              className="flex"
                                              onClick={() =>
                                                handleDeleteNewServiceRequestItem(
                                                  item
                                                )
                                              }
                                            >
                                              <IconDelete />
                                            </div>
                                          </Tooltip>
                                        )}

                                      {SERVICE_REQUEST_STATUS[0].value ===
                                      item?.itemStatus ? (
                                        <></>
                                      ) : (
                                        <>
                                          <Tooltip title="Xem kết quả">
                                            <span
                                              onClick={() => {
                                                handleOpenTreatmentResultPopup(
                                                  item
                                                );
                                              }}
                                            >
                                              🖼️🔍
                                            </span>
                                          </Tooltip>
                                        </>
                                      )}
                                    </div>
                                  ) : (
                                    <div className="flex-center gap-2">
                                      {canEditPatient && (
                                        <Tooltip
                                          title="Cập nhật thông tin dịch vụ"
                                          placement="top"
                                          arrow
                                        >
                                          <IconButton
                                            size="small"
                                            className="actionButton"
                                            onClick={() =>
                                              handleOpenAllocationServicePopup(
                                                item?.id
                                              )
                                            }
                                          >
                                            <AssignmentIcon
                                              style={{ color: "#008693" }}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      )}

                                      {canDeletePatient && (
                                        <Tooltip
                                          title="Xóa chỉ định dịch vụ"
                                          placement="top"
                                          arrow
                                        >
                                          <div
                                            className="flex"
                                            onClick={() =>
                                              handleDeleteNewServiceRequestItem(
                                                item
                                              )
                                            }
                                          >
                                            <IconDelete />
                                          </div>
                                        </Tooltip>
                                      )}

                                      {SERVICE_REQUEST_STATUS[0].value ===
                                      item?.itemStatus ? null : (
                                        <Tooltip title="Kết quả">
                                          <span
                                            onClick={() =>
                                              handleOpenTreatmentResultPopup(
                                                item
                                              )
                                            }
                                          >
                                            🖼️🔍
                                          </span>
                                        </Tooltip>
                                      )}
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                            {visibleFields["service"] && (
                              <div className="field">
                                <strong>Dịch vụ:</strong>
                                <div className="pl-1 pr-1">
                                  <div>
                                    <span className="service-code">
                                      {item?.service?.code}
                                    </span>{" "}
                                    <span className="service-name">
                                      {item?.service?.tradeName ||
                                        item?.service?.name}
                                    </span>
                                    {item?.patientServiceRegisterCode && (
                                      <>
                                        {" - "}
                                        <span
                                          className="order-code"
                                          style={{
                                            color: "#888",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {item?.patientServiceRegisterCode}
                                        </span>
                                      </>
                                    )}
                                    {item?.treatmentType ===
                                      SERVICE_TREATMENT_TYPE_WARRANTY && (
                                      <div
                                        style={{
                                          color: "red",
                                          fontSize: "12px",
                                        }}
                                      >
                                        (dịch vụ bảo hành{" "}
                                        {item?.service?.warrantyService?.name})
                                      </div>
                                    )}
                                  </div>

                                  {item?.times && (
                                    <>
                                      <div className="font-size-12">
                                        {`Lần  ${
                                          item?.treatmentType ===
                                          SERVICE_TREATMENT_TYPE_WARRANTY
                                            ? "bảo hành"
                                            : "điều trị"
                                        }: ${item?.times || 0} ${
                                          item?.unLimited
                                            ? "♾️"
                                            : "| " +
                                              (item?.totalTreatmentTimes || 0)
                                        }`}
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            )}
                            {visibleFields["currentVolumeTreated"] && (
                              <div className="field">
                                <strong>Số lượng điều trị:</strong>
                                <div>
                                  {item?.currentVolumeTreated}
                                  {item?.treatUnit}
                                </div>
                              </div>
                            )}
                            {visibleFields["result"] && (
                              <div className="field">
                                <strong>Kết quả:</strong>
                                {item?.diagnosticReport ? (
                                  <div>
                                    <div>
                                      <strong>Kết luận:</strong>{" "}
                                      {item?.diagnosticReport?.conclude ||
                                        "Không có"}
                                    </div>
                                    <div>
                                      <strong>Ghi chú:</strong>{" "}
                                      {item?.diagnosticReport?.note ||
                                        "Không có"}
                                    </div>
                                  </div>
                                ) : (
                                  <i style={{ color: "#999" }}>
                                    Chưa có kết quả
                                  </i>
                                )}
                              </div>
                            )}

                            {visibleFields["department"] && (
                              <div className="field">
                                <strong>Cơ sở:</strong>{" "}
                                {item?.department?.name || ""}
                              </div>
                            )}

                            {visibleFields["isOutsideDepartment"] && (
                              <div className="field">
                                <strong>Làm ngoài cơ sở không:</strong>
                                <input
                                  type="checkbox"
                                  checked={!!item?.isOutsideDepartment}
                                  disabled
                                  readOnly
                                  style={{ marginLeft: "8px" }}
                                />
                              </div>
                            )}

                            {visibleFields["room"] && (
                              <div className="field">
                                <strong>Phòng:</strong> {item?.room?.name || ""}
                              </div>
                            )}

                            {visibleFields["assigner"] && (
                              <div className="field">
                                <strong>Người chỉ định:</strong>{" "}
                                {item?.assigner?.staffName || ""}
                              </div>
                            )}

                            {visibleFields["orderDateDetail"] && (
                              <div className="field">
                                <strong>Ngày chỉ định:</strong>{" "}
                                {getDateTime(item?.orderDate)}
                              </div>
                            )}

                            {visibleFields["performDate"] && (
                              <div className="field">
                                <strong>Thời gian thực hiện:</strong>{" "}
                                {getDateTime(item?.performDate)}
                              </div>
                            )}

                            {visibleFields["performer"] && (
                              <div className="field">
                                <strong>Người thực hiện:</strong>
                                {item?.encounterParticipants?.map((el, ind) => (
                                  <div>
                                    <span className="service-name">
                                      {el?.staff?.staffName}
                                      {": "}
                                    </span>
                                    <span
                                      className="service-code"
                                      style={{
                                        fontWeight: "400",
                                        fontSize: "12px",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      {el?.position?.name}{" "}
                                      {el?.isMain ? " - ⭐" : ""}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            )}

                            {visibleFields["status"] && (
                              <div className="field">
                                <strong>Trạng thái:</strong>{" "}
                                <span>
                                  {SERVICE_REQUEST_STATUS?.find(
                                    (it) => it.value === item?.itemStatus
                                  )?.name || t("Chưa xác định")}
                                </span>
                              </div>
                            )}

                            {visibleFields["hasImg"] && (
                              <div className="field">
                                <strong>Đã up ảnh:</strong>
                                {item?.hasImg ? "✔️" : "❌"}
                              </div>
                            )}

                            {visibleFields["note"] && (
                              <div className="field">
                                <strong>Ghi chú:</strong> {item?.note || ""}
                              </div>
                            )}

                            {visibleFields["createdInfo"] && (
                              <div className="field">
                                <strong>Thông tin tạo / sửa:</strong>
                                <div className="sub-field">
                                  <div>
                                    <strong>Tạo:</strong>{" "}
                                    {item?.createdBy || ""}
                                  </div>
                                  <div>
                                    <strong>Sửa:</strong>{" "}
                                    {item?.modifiedBy || ""}
                                  </div>
                                </div>
                              </div>
                            )}

                            {visibleFields["createDateInfo"] && (
                              <div className="field">
                                <strong>
                                  Ngày tạo HT / Thời gian nhập (theo HT):
                                </strong>
                                <div className="sub-field">
                                  <div>
                                    <strong>Tạo HT:</strong>{" "}
                                    {getDateTime(item?.createDate)}
                                  </div>
                                  <div>
                                    <strong>Nhập KQ (HT):</strong>{" "}
                                    {getDateTime(
                                      item?.createDateDiagnosticReport
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </>
                </div>
              </>
            );
          })}
        </div>
      </Grid>
    </Grid>
  );
};

const ExtraButton = ({ setVisibleColumns, visibleColumns, columns }) => {
  const classes = useStylesExtraButton();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const visibleColumnsFormat = Object.entries(visibleColumns);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const id = !!anchorEl ? "simple-popover" : undefined;
  const onToggle = (index, state) => {
    let newArr = visibleColumnsFormat?.map((el, ind) => {
      if (ind === index) return [el[0], state];
      else return el;
    });
    const obj = Object.fromEntries(newArr);
    setVisibleColumns(obj);

    localStorage.setItem("dataMobileTreatmentCustom", JSON.stringify(obj));
    return newArr;
  };

  return (
    <div>
      <Button
        aria-describedby={id}
        variant="contained"
        color="primary"
        onClick={handleClick}
        className="extra-button-table"
      >
        <div className="flex align-center justify-between">
          {"Xem thêm"}
          <Tooltip title="Xem thêm">
            {!!anchorEl ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
          </Tooltip>
        </div>
      </Button>
      <Popover
        id={id}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Typography className={classes.typography}>
          {visibleColumnsFormat &&
            visibleColumnsFormat?.map((el, index) => (
              <CustomToggle
                el={el}
                onToggle={onToggle}
                index={index}
                columns={columns}
              />
            ))}
        </Typography>
      </Popover>
    </div>
  );
};

const CustomToggle = ({ onToggle, el, index, columns }) => {
  const [active, setActive] = useState(el[1]);

  const handleClick = (index) => {
    setActive((prev) => !prev);
    if (onToggle) {
      onToggle(index, !active);
    }
  };

  return (
    <div className="flex gap-2 align-center toggle-wraper">
      <div className="toggle-container">
        <div
          className={`custom-toggle ${active ? "active" : ""}`}
          onClick={() => handleClick(index)}
        >
          <div className="toggle-circle" />
        </div>
        <div className="flex justify-between align-center" style={{ flex: 1 }}>
          <span className="toggle-label">{columns[el[0]]}</span>
        </div>
      </div>
    </div>
  );
};

export default memo(observer(ListTreatmentMobile));
